import { useQuery } from "@tanstack/react-query";
import { getAllMachineApiRequest } from "../../services";
import { useCommonStore } from "../../store";

export const useGetAllMachineApi = () => {
  const { reload } = useCommonStore()
  const { data, isLoading } = useQuery({
    queryKey: ["all", "all-machine-of-store", "all-machine", reload],
    queryFn: () => getAllMachineApiRequest(),
    enabled: true,
  });
  return {
    machines: data,
    isLoading,
  };
};
